import * as uiAnalyticsConsumer from '@servicenow/ui-analytics-consumer';
import {levels} from './constants';
const {createHistogram} = uiAnalyticsConsumer;
const types = {};
for (const k in levels) {
	types[k] = {
		level: levels[k],
		histogram: createHistogram(k)
	};
}

export default types;
